import _objectSpread from "/opt/bitnami/apache/htdocs/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "/opt/bitnami/apache/htdocs/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/opt/bitnami/apache/htdocs/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import classNames from 'classnames';
import * as React from 'react';
import SelectableContext from '@restart/ui/SelectableContext';
import TabContext from '@restart/ui/TabContext';
import { useTabPanel } from '@restart/ui/TabPanel';
import { useBootstrapPrefix } from './ThemeProvider';
import Fade from './Fade';
import getTabTransitionComponent from './getTabTransitionComponent';
import { jsx as _jsx } from "react/jsx-runtime";
var TabPane = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
    transition = _ref.transition,
    props = _objectWithoutProperties(_ref, ["bsPrefix", "transition"]);
  var _useTabPanel = useTabPanel(_objectSpread({}, props, {
      transition: getTabTransitionComponent(transition)
    })),
    _useTabPanel2 = _slicedToArray(_useTabPanel, 2),
    _useTabPanel2$ = _useTabPanel2[0],
    className = _useTabPanel2$.className,
    _useTabPanel2$$as = _useTabPanel2$.as,
    Component = _useTabPanel2$$as === void 0 ? 'div' : _useTabPanel2$$as,
    rest = _objectWithoutProperties(_useTabPanel2$, ["className", "as"]),
    _useTabPanel2$2 = _useTabPanel2[1],
    isActive = _useTabPanel2$2.isActive,
    onEnter = _useTabPanel2$2.onEnter,
    onEntering = _useTabPanel2$2.onEntering,
    onEntered = _useTabPanel2$2.onEntered,
    onExit = _useTabPanel2$2.onExit,
    onExiting = _useTabPanel2$2.onExiting,
    onExited = _useTabPanel2$2.onExited,
    mountOnEnter = _useTabPanel2$2.mountOnEnter,
    unmountOnExit = _useTabPanel2$2.unmountOnExit,
    _useTabPanel2$2$trans = _useTabPanel2$2.transition,
    Transition = _useTabPanel2$2$trans === void 0 ? Fade : _useTabPanel2$2$trans;
  var prefix = useBootstrapPrefix(bsPrefix, 'tab-pane');

  // We provide an empty the TabContext so `<Nav>`s in `<TabPanel>`s don't
  // conflict with the top level one.
  return /*#__PURE__*/_jsx(TabContext.Provider, {
    value: null,
    children: /*#__PURE__*/_jsx(SelectableContext.Provider, {
      value: null,
      children: /*#__PURE__*/_jsx(Transition, {
        in: isActive,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: onExited,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        children: /*#__PURE__*/_jsx(Component, _objectSpread({}, rest, {
          ref: ref,
          className: classNames(className, prefix, isActive && 'active')
        }))
      })
    })
  });
});
TabPane.displayName = 'TabPane';
export default TabPane;